import { useContext, useState } from "react";
import { useToast } from "../ToastContext";
import { LoadingContext } from "../LoadingContext";
import { AuthContext } from "../AuthContext";
import {
  getMessageTitleByUserIdGat,
  updateMessageTitleGat,
} from "../../gateways/SettingsGateway";

export default function useSettings() {
  const showToast = useToast();
  const { setLoading } = useContext(LoadingContext);
  const { objUserTk } = useContext(AuthContext);

  const [messageTitle, setMessageTitle] = useState<string>("");
  const [messageEmailBody, setMessageEmailBody] = useState<string>("");

  const updateMessageTitle = async (newTitle: string, newEmailBody?: string) => {
    try {
      setLoading(true);
      console.log("newEmailBody", newEmailBody);
      const result = await updateMessageTitleGat(objUserTk.UserId, newTitle, newEmailBody);
      if (result) {
        showToast("success", "Sucesso ao atualizar");
        setLoading(false);
      }
    } catch (error: any) {
      console.log(error);
      showToast(
        "error",
        error?.response?.data?.error?.message || "Erro ao cadastrar"
      );
      setLoading(false);
    }
  };

  const getMessageTitleByUserId = async (UserId: string) => {
    try {
      setLoading(true);
      const result = await getMessageTitleByUserIdGat(UserId);
      setMessageTitle(result.data?.messageTitle || "");
      setMessageEmailBody(result.data?.emailBody || "");
      setLoading(false);
      return result.data;
    } catch (error: any) {
      console.log(error);
      // showToast(
      //   "error",
      //   error?.response?.data?.error?.message || "Erro ao buscar"
      // );
      setLoading(false);
    }
  };

  return {
    messageTitle,
    updateMessageTitle,
    setMessageTitle,
    getMessageTitleByUserId,
    messageEmailBody, 
    setMessageEmailBody
  };
}
